module.exports = __webpack_public_path__ + "static/media/10H.60ab387c.png";